import { NAV_CONFIG_ITEMS } from "../consts";
import NavConfigRov from "./ NavConfigRow";

const NavConfigRows = () => {
  const elm = document.createElement("div");
  elm.classList.add("nav-configs");
  NAV_CONFIG_ITEMS.forEach(config => {
    elm.append(NavConfigRov(config));
  });
  return elm;
};

export default NavConfigRows;
